import { useEffect, useState } from 'react';
// animation
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Button } from '../UI/Button/Button';
import ContactModal from '../UI/Modal/ContactModal/ContactModal';
// style
import style from './contact.module.css';
import bg1 from '../../assets/header-img/2.png';
import bg2 from '../../assets/header-img/4.jpg';

const Contact = ({ text, bg }) => {
  const [modalIsOpen, setModal] = useState(false);

  // animation effect
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handelModal = () => {
    setModal(!modalIsOpen);
    !modalIsOpen
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'visible');
  };
  return (
    <section
      className={style.section}
      style={
        bg
          ? { backgroundImage: `url(${bg1})` }
          : { backgroundImage: `url(${bg2})` }
      }
    >
      <div className="container">
        <div className={style.content}>
          <div className={style.title}>
            <h2 data-aos="fade-up">{text}</h2>
          </div>
          <div className={style.buttons}>
            <div data-aos="fade-up">
              <a href="tel:+78432587427">
                <Button text="+7-843-258-74-27" type={true} />
              </a>
            </div>
            <div
              onClick={() => handelModal()}
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <Button text="Обратный звонок" type={true} />
            </div>
          </div>
        </div>
      </div>
      <ContactModal modalIsOpen={modalIsOpen} handelModal={handelModal} />
    </section>
  );
};
export default Contact;
